import AxisBank from '../../images/icons/CommisionIcons/AxisBank.png';
import AxisFinance from '../../images/icons/CommisionIcons/AxisFinance.png';

import BankofBaroda from '../../images/icons/CommisionIcons/BankofBaroda.png';
import Cholamandalam from '../../images/icons/CommisionIcons/Cholamandalam.png';
import DCB_icon from '../../images/icons/CommisionIcons/DCB_icon.png';
import DeutscheBank from '../../images/icons/CommisionIcons/DeutscheBank.png';
import HDFC_icon from '../../images/icons/CommisionIcons/HDFC_icon.png';
import SBI_icon from '../../images/icons/CommisionIcons/SBI_icon.png';
import FedBank from '../../images/icons/CommisionIcons/FedBank.png';
import FedFINA_bank from '../../images/icons/CommisionIcons/FedFINA_bank.png';
import PNB_bank from '../../images/icons/CommisionIcons/PNB_bank.png';
import SriramCityUnion from '../../images/icons/CommisionIcons/SriramCityUnion.png';
import StandardChartered_bank from '../../images/icons/CommisionIcons/StandardChartered_bank.png';
import RBL_bank from '../../images/icons/CommisionIcons/RBL_bank.png';
import LT_finance_bank from '../../images/icons/CommisionIcons/LT_finance_bank.png';
import IDFC_bank from '../../images/icons/CommisionIcons/IDFC_bank.png';
import LIC_bank from '../../images/icons/CommisionIcons/LIC_bank.png';
import HDBFinance from '../../images/icons/CommisionIcons/HDBFinance.png';
import ShriramHousing from '../../images/icons/CommisionIcons/ShriramHousing.png';
import KotakBank from '../../images/icons/CommisionIcons/KotakBank.png';
import HDFCLtd from '../../images/icons/CommisionIcons/HDFCLtd.png';
import TataHousingFinance from '../../images/icons/CommisionIcons/TataHousingFinance.png';
import ICICIHomeFinance from '../../images/icons/CommisionIcons/ICICIHomeFinance.png';
import ICICI_bank from '../../images/icons/CommisionIcons/ICICI_bank.png';
import TATA_Capital from '../../images/icons/CommisionIcons/TATA_Capital.png';
import Yes_bank from '../../images/icons/CommisionIcons/Yes_bank.png';

import AdityaBirlaCapital_icon from '../../images/icons/CommisionIcons/AdityaBirlaCapital_icon.png';
const CommisionData = [
  {
    SL_No: 1,
    bankName: 'Aditya Birla Capital',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: AdityaBirlaCapital_icon
  },
  {
    SL_No: 2,
    bankName: 'Axis Bank',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: AxisBank
  },
  {
    SL_No: 3,
    bankName: 'Axis Finance',
    HLpercentage: 'NA',
    LAPpercentage: '0.70%',
    imgUrl: AxisFinance
  },
  {
    SL_No: 4,
    bankName: 'Bank of Baroda (BOB)',
    HLpercentage: '0.20%',
    LAPpercentage: '0.20%',
    imgUrl: BankofBaroda
  },
  {
    SL_No: 5,
    bankName: 'Cholamandalam',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: Cholamandalam
  },
  {
    SL_No: 6,
    bankName: 'DCB',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: DCB_icon
  },
  {
    SL_No: 7,
    bankName: 'Deutsche Bank',
    HLpercentage: 'NA',
    LAPpercentage: '0.75%',
    imgUrl: DeutscheBank
  },
  {
    SL_No: 8,
    bankName: 'Fed Bank',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: FedBank
  },
  {
    SL_No: 9,
    bankName: 'Fed FINA',
    HLpercentage: 'NA',
    LAPpercentage: '0.75%',
    imgUrl: FedFINA_bank
  },
  {
    SL_No: 10,
    bankName: 'HDFC Bank',
    HLpercentage: 'NA',
    LAPpercentage: '0.70%',
    imgUrl: HDFC_icon
  },
  {
    SL_No: 11,
    bankName: 'HDFC Ltd',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: HDFCLtd
  },
  {
    SL_No: 12,
    bankName: 'HDB Finance',
    HLpercentage: 'NA',
    LAPpercentage: '0.70%',
    imgUrl: HDBFinance
  },
  {
    SL_No: 13,
    bankName: 'ICICI Bank',
    HLpercentage: '0.30%',
    LAPpercentage: '0.35%',
    imgUrl: ICICI_bank
  },
  {
    SL_No: 14,
    bankName: 'ICICI Home Finance',
    HLpercentage: '0.30%',
    LAPpercentage: '0.35%',
    imgUrl: ICICIHomeFinance
  },
  {
    SL_No: 15,
    bankName: 'IDFC',
    HLpercentage: '0.50%',
    LAPpercentage: '0.75%',
    imgUrl: IDFC_bank
  },
  {
    SL_No: 16,
    bankName: 'Kotak Bank',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: KotakBank
  },
  {
    SL_No: 17,
    bankName: 'LIC Housing',
    HLpercentage: '0.30%',
    LAPpercentage: '0.30%',
    imgUrl: LIC_bank
  },
  {
    SL_No: 18,
    bankName: 'L&T Finance',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: LT_finance_bank
  },
  {
    SL_No: 19,
    bankName: 'PNB Housing',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: PNB_bank
  },
  {
    SL_No: 20,
    bankName: 'RBL',
    HLpercentage: 'NA',
    LAPpercentage: '0.70%',
    imgUrl: RBL_bank
  },
  {
    SL_No: 21,
    bankName: 'SBI',
    HLpercentage: '0.20%',
    LAPpercentage: '0.20%',
    imgUrl: SBI_icon
  },
  {
    SL_No: 22,
    bankName: 'Standard Chartered',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: StandardChartered_bank
  },
  {
    SL_No: 23,
    bankName: 'Sriram City Union',
    HLpercentage: 'NA',
    LAPpercentage: '0.70%',
    imgUrl: SriramCityUnion
  },
  {
    SL_No: 24,
    bankName: 'Shriram Housing',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: ShriramHousing
  },
  {
    SL_No: 25,
    bankName: 'Tata Housing Finance',
    HLpercentage: '0.50%',
    LAPpercentage: '0.70%',
    imgUrl: TataHousingFinance
  },
  {
    SL_No: 26,
    bankName: 'TATA Capital',
    HLpercentage: 'NA',
    LAPpercentage: '0.70%',
    imgUrl: TATA_Capital
  },
  {
    SL_No: 27,
    bankName: 'Yes Bank',
    HLpercentage: '0.50%',
    LAPpercentage: '0.75%',
    imgUrl: Yes_bank
  }
];

export default CommisionData;
